import { Component, inject, input, signal } from '@angular/core';
import { StateService } from '@uirouter/core';

/**
 * People guest-detail modal, rendered as a UIRouter-hybrid native component state
 * (`people.directory.details` / `people.feedback.details`). A native `<ft-modal-overlay>`
 * (CDK body-portal) wraps the `.ft-person-modal` tree; the header name comes from
 * PeopleDetailsBodyComponent's `(loaded)` output via the shared `fullName` pipe.
 *
 * `advocateUuid` / `curate` are bound from UIRouter state resolves. The modal lives for the
 * state's lifetime and `close()` transitions to the parent, destroying this component.
 */
@Component({
    selector: 'ft-people-details',
    templateUrl: './details.component.html',
    standalone: false
})
export class DetailsComponent {
    readonly advocateUuid = input.required<string>();
    readonly curate = input(false);

    protected readonly headerAdvocate = signal<any>(undefined);
    protected readonly headerPii = signal(false);

    private readonly stateService = inject(StateService);

    protected onBodyLoaded(event: { advocate: any; isPiiInfoVisible: boolean }): void {
        this.headerAdvocate.set(event.advocate);
        this.headerPii.set(event.isPiiInfoVisible);
    }

    /** Matches v1's `vm.close()` — back to the parent (directory / feedback) state. */
    protected close(): void {
        this.stateService.go('^');
    }
}
